export enum ErrorType {
  TOKEN,
  NETWORK,
  UNKNOWN,
  UNAVAILABLE,
}
